import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@lt/components';
import { useTranslation } from '@lt/localization';

const HEIGHT = 44;
const TRIANGLE_HEIGHT = HEIGHT / 2 - 1;
const TRIANGLE_WIDTH = 10;

const StyledButton = styled(Button).attrs({
  size: 'flex',
})`
  position: relative;
  margin-left: ${TRIANGLE_WIDTH}px;
  padding: 0 10px;
  height: ${HEIGHT}px;
  font-size: 10px;
  letter-spacing: 0.77px;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.blackBase};
  background-color: ${(props) => props.theme.colors.white};

  &::before,
  &::after {
    position: absolute;
    z-index: 2;
    top: 0;
    left: -${TRIANGLE_WIDTH - 1}px;
    width: 0;
    height: 0;
    content: '';
    border-top: ${TRIANGLE_HEIGHT}px solid transparent;
    border-right: ${TRIANGLE_WIDTH}px solid
      ${(props) => props.theme.colors.white};
    border-bottom: ${TRIANGLE_HEIGHT}px solid transparent;
  }

  &::before {
    z-index: 1;
    left: -${TRIANGLE_WIDTH}px;
    content: '';
    border-top: ${TRIANGLE_HEIGHT}px solid transparent;
    border-right: ${TRIANGLE_WIDTH}px solid
      ${(props) => props.theme.colors.blue};
    border-bottom: ${TRIANGLE_HEIGHT}px solid transparent;
  }
`;

const MobileBackButton = (props) => {
  const { t } = useTranslation();
  return (
    <StyledButton {...props}>
      {t('hotel.cigarette.mobile.backButton')}
    </StyledButton>
  );
};

MobileBackButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default MobileBackButton;
